import React from "react"
import { styled } from "../stitches.config";

import logo from "../assets/img/natemat/logo_white_orange_dot.svg"

const HardcoverLogo = ({ className }) => {
    return (
        <Wrap className={`hardcoverLogo ${className ?? ""}`}>
            <span>
                magazyn
            </span>
            <img src={logo} />
        </Wrap>
    )
};

HardcoverLogo.toString = ()=> ".hardcoverLogo";

const Wrap = styled("div", {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-end",
    "span": {
        color: "white",
        display: "block",
        height: "28px"
    },
    "img": {
        width: "140px"
    }
});

export default HardcoverLogo;